export default {
  "language": "vi",
  "message":
    {
      "title": "Máy tính tiền thưởng nhà ở thu nhập hỗn hợp",
      "zoningDistrict": "Chọn quận phân vùng",
      "affordabilityLevel": "Chọn mức khả năng chi trả",
      "allThatApply": "Chọn tất cả những gì áp dụng.",
      "springGardenS": "Là dự án nằm ở phía nam đường Spring Garden",
      "yes": "Vâng",
      "no": "Không",
      "affordability": {
        "lowIncome": "Thu nhập thấp",
        "moderateIncome": "Thu nhập vừa phải",
      },
      "lotAreaSqft": "Nhập diện tích lô bằng feet vuông",
      "buildingHeight": "Nhập chiều cao tòa nhà",
      "totalUnits": "Số lượng căn đề xuất trong dự án: ",
      "unitsEarnedLow": "Các đơn vị bổ sung kiếm được (Thu nhập thấp):",
      "unitsEarnedMod": "Các đơn vị bổ sung kiếm được (Thu nhập vừa phải):",
      "greenRoofBonus": "Số lượng đơn vị thưởng mái nhà xanh:",
      "modIncomePayment": "Thanh toán ước tính thu nhập vừa phải:",
      "lowIncomePayment": "Thanh toán ước tính thu nhập thấp:",
      "requiredAffordableUnits": "Đơn vị giá cả phải chăng MIHB bắt buộc:",
      "requiredMinAffordableUnits": "Đơn vị giá cả phải chăng /MIN cần thiết:",
      "totalRequiredAffordabilityUnits": "Tổng số đơn vị giá cả phải chăng cần thiết:",
      "additionalFar": "Thêm FAR kiếm được:",
      "totalFar": "Tổng FAR:",
      "totalFloor": "Tổng diện tích sàn được phép:",
      "overlay": {
        "fithDistrict": "Dự án này nằm trong Quận Lớp phủ Quận 5 (/VDO).",
        "greenRoof": "Dự án này sẽ kiếm được Tiền thưởng Mái nhà Xanh.",
        "minMixed": "Dự án này nằm trong Lớp phủ Khu dân cư Thu nhập Hỗn hợp /MIN. ",
        "todDevelopement": "Dự án này nằm trong Lớp phủ Phát triển Định hướng Chuyển tuyến /TOD.",
      },
      "sFHA": [
        "Khu vực nguy hiểm lũ lụt đặc biệt",
      ],
      "numberOfDwellingUnits": "Số lượng đơn vị nhà ở được phép theo phân vùng cơ sở:",
      "about": "Về",
      "aboutTitle": "Về tiền thưởng nhà ở thu nhập hỗn hợp",
      "aboutSubTitle": "Cách sử dụng máy tính",
      "paragraphOne": "Phần thưởng nhà ở thu nhập hỗn hợp dành cho các nhà phát triển thêm nhà ở giá cả phải chăng vào các dự án của họ hoặc trả vào quỹ hỗ trợ nhà ở giá rẻ. Đổi lại, sự phát triển nhận được nhiều diện tích sàn, chiều cao và/hoặc các đơn vị nhà ở “bên phải” hơn. Các nhà phát triển có thể chọn từ hai mức tiền thưởng. Mức thu nhập vừa phải là một phần thưởng nhỏ hơn, nhưng nó có tiêu chuẩn khả năng chi trả ít nghiêm ngặt hơn hoặc số tiền thanh toán thấp hơn. Mức thu nhập thấp là một phần thưởng lớn hơn, nhưng nó có tiêu chuẩn khả năng chi trả chặt chẽ hơn hoặc số tiền thanh toán cao hơn.",
      "paragraphTwo": {
        "text": "Máy tính tiền thưởng nhà ở thu nhập hỗn hợp được sử dụng để ước tính chính xác:",
        "bullets": [
          "Tổng số đơn vị được phép.",
          "Tổng số đơn vị giá cả phải chăng mà bạn sẽ được yêu cầu cung cấp.",
          "Phí thay cho số tiền phải trả cho một sự phát triển sử dụng tiền thưởng nhà ở thu nhập hỗn hợp.",
        ],
      },
      "paragraphThree": {
        "text": "Để bắt đầu, hãy chọn khu phân vùng cơ sở của bất động sản và nhập khu vực lô đất của nó. Bạn cũng nên chọn bất kỳ quận lớp phủ áp dụng nào. Bạn có thể sử dụng",
        "link": {
          "text": "bản đồ",
          "p": {
            "url": "https://atlas.phila.gov/",
          },
        },
        "continuation": "để tìm thông tin này.",
      },
      "finalConfirmation": "Máy tính này được sử dụng để lập kế hoạch dự án khái niệm. Trường hợp có sự khác biệt giữa máy tính và Bộ luật Phân vùng Philadelphia, Bộ luật Phân vùng Philadelphia sẽ điều chỉnh. Xác nhận cuối cùng về các đơn vị, số lượng căn hộ giá cả phải chăng được yêu cầu và/hoặc số tiền phí thay thế sẽ được nhân viên Ủy ban Quy hoạch Thành phố Philadelphia thực hiện trong quá trình xem xét giấy phép phân vùng. ",
      "resources": "Tài nguyên",
      "code1": {
        "link": {
          "text": "Mã Philadelphia - 14-702 (7) - Tiền thưởng nhà ở thu nhập hỗn hợp",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-293117",
          },
        },
      },
      "code2": {
        "link": {
          "text": "Mã Philadelphia - 14-533 - Khu phủ vùng lân cận thu nhập hỗn hợp",
          "p": {
            "url": "https://codelibrary.amlegal.com/codes/philadelphia/latest/philadelphia_pa/0-0-0-291906",
          },
        },
      },
      "facts": {
        "link": {
          "text": "Tờ thông tin về tiền thưởng nhà ở thu nhập hỗn hợp",
          "p": {
            "url": "https://www.phila.gov/documents/affordable-housing-zoning-bonus-review-application/",
          },
        },
      },
    },
};